import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import PropTypes from 'prop-types';
import AuthenticationFactorListItemContactAction
  from 'Views/Page/Content/Templates/SettingsTemplate/Content/AuthenticationFactorTemplate/AuthenticationFactorsCard/AuthenticationFactorListPicker/AuthenticationFactorList/Content/AuthenticationFactorListItem/AuthenticationFactorListItemModifyActionPicker/AuthenticationFactorListItemContactAction';
import AuthenticationFactorListItemModifyAction
  from './AuthenticationFactorListItemModifyAction';

const AuthenticationFactorListItemActionPicker = ({ authenticationFactorResource }) => {
  if (authenticationFactorResource.attr('enabled') === 'false') {
    return null;
  }
  return pickFunction(authenticationFactorResource, {
    [fr.relationships.authenticationFactorModify.name]: () => {
      return <AuthenticationFactorListItemModifyAction authenticationFactorResource={authenticationFactorResource} />;
    },
    [fr.relationships.default.name]: () => {
      return <AuthenticationFactorListItemContactAction authenticationFactorResource={authenticationFactorResource} />;
    },
  });
};

AuthenticationFactorListItemActionPicker.propTypes = {
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default AuthenticationFactorListItemActionPicker;
